import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

/**
 * The mock's data, generated from the local database by
 * workbench/backlog/feature_watchdog/issues-page/notes/gen-issues-fixture.mjs into public/, one file
 * per workspace, gitignored there. Absolute, because package.json sets "homepage": "." and a relative
 * URL would resolve against the route.
 */
const fixtureUrlOf = (workspaceNumber) => `/watchdog/${workspaceNumber}/issues.json`;

const pending = new Map();

const fetchFixture = (workspaceNumber) => {
    if (!pending.has(workspaceNumber)) {
        const url = fixtureUrlOf(workspaceNumber);
        pending.set(workspaceNumber, fetch(url).then((response) => {
            if (!response.ok) throw new Error(`${response.status} fetching ${url}`);
            // A build without the file answers every path with index.html and a 200.
            if (!(response.headers.get("content-type") || "").includes("json")) throw new Error(`${url} is not there`);
            return response.json();
        }).catch((error) => { pending.delete(workspaceNumber); throw error; }));
    }
    return pending.get(workspaceNumber);
};

/** The route's workspace's Issues fixture. */
export const useIssuesFixture = () => {
    const { workspaceNumber } = useParams();
    const [state, setState] = useState({ fixture: null, error: null });

    useEffect(() => {
        let live = true;
        setState({ fixture: null, error: null });
        fetchFixture(workspaceNumber).then(
            (fixture) => live && setState({ fixture, error: null }),
            (error) => live && setState({ fixture: null, error: error.message }),
        );
        return () => { live = false; };
    }, [workspaceNumber]);

    return state;
};
